/* MOWOW — Cart company fields
   Persists data into cart.attributes via /cart/update.js so values survive AJAX cart updates.
*/

(function () {
  function debounce(fn, delay) {
    let t;
    return function (...args) {
      window.clearTimeout(t);
      t = window.setTimeout(() => fn.apply(this, args), delay);
    };
  }

  async function updateCartAttributes(attributes) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ attributes }),
      });
    } catch (e) {
      // Silent failure: checkout submission will still include form fields as a fallback.
      console.warn('[MOWOW] Failed to update cart attributes', e);
    }
  }

  function setup(root) {
    const toggle = root.querySelector('[data-mowow-company-toggle]');
    const details = root.querySelector('[data-mowow-company-details]');
    const nameInput = root.querySelector('input[name="attributes[mowow_company_name]"]');
    const vatInput = root.querySelector('input[name="attributes[mowow_company_vat]"]');

    if (!toggle || !details) return;

    function collectAttributes() {
      const enabled = toggle.checked;
      return {
        mowow_company_invoice: enabled ? 'yes' : '',
        mowow_company_name: enabled ? (nameInput?.value || '') : '',
        mowow_company_vat: enabled ? (vatInput?.value || '') : '',
      };
    }

    function syncVisibility() {
      details.hidden = !toggle.checked;
    }

    const persist = () => updateCartAttributes(collectAttributes());
    const persistDebounced = debounce(persist, 500);

    toggle.addEventListener('change', () => {
      syncVisibility();

      // When disabling, clear values to avoid stale attributes in checkout.
      if (!toggle.checked) {
        if (nameInput) nameInput.value = '';
        if (vatInput) vatInput.value = '';
      }

      persist();
    });

    if (nameInput) nameInput.addEventListener('input', persistDebounced);
    if (vatInput) vatInput.addEventListener('input', persistDebounced);

    syncVisibility();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-mowow-company-fields]').forEach(setup);
  });
})();
